import { inferDeployStageLabel } from '../../utils/deployStage';

/** Deploy stage badge label for the demo agency setup Internal Tools panel. */
export function inferDemoAgencySetupStageLabel(): string {
  return inferDeployStageLabel();
}

/** False in production — panel must not render; API is also unmounted there. */
export function isDemoAgencySetupPanelEnabled(): boolean {
  return inferDemoAgencySetupStageLabel().toLowerCase() !== 'prod';
}
